import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Switch, message } from 'antd';
import common from '@/asserts/js/common';
import i18n from '@/lang';
import { 
  leftImg,
  leftLightImg,
  closeImg,
  closeOnImg,
  closeOnLightImg,
  checkOffImg,
  settingOnImg
} from '@/asserts/imgs/common/index';
import RiskComponents from '@/components/modal/risk/index';
import OnlineComponents from '@/components/modal/online/index';
import AgreeComponents from '@/components/modal/agree/index';
import AgreeNoticeComponents from '@/components/modal/agreeNotice/index';
import APPstyles from '@/App.less';
import styles from './index.less';

class settingIndex extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      langData:[
        {
          name:'繁體中文',
          lang:'zh-CN'
        },
        {
          name:'English',
          lang:'en-US'
        }
      ],
      notificationsData:[
        {
          name:'Hide Alert Notifications',
          isShow:false
        },
        {
          name:'Notifications Sound',
          isShow:true
        }
      ],
      getTheme:'Dark',
      getLang:'zh-CN',
      langIndex:0,
      isDarkMode:true,
      isSettingPageShow:false,
      minH550:550,
      chgCloseImg:closeImg,
      simpleTradeData:{isShow:false},
      riskVisible:false,
      onlineVisible:false,
      agreeVisible:false,
      agreeNoticeVisible:false,
      riskStatus:'',
      loading:true,
      isSwitchAccount:false
    }
  }
  // 取消
  cancelClick(){
    const {isSwitchAccount}=this.state;

    this.props.cbCloseSetting(false);

    if(isSwitchAccount){
      this.updateMainPage();
    }else{
      this.chgNavIndexfun();
    }
  };
  //语言设置页面--save
  saveClick(){
    const {getTheme,getLang,notificationsData,simpleTradeData,isSwitchAccount}=this.state;
    let locale=i18n.language=getLang
    let tradeName=simpleTradeData['isShow']?'simple':'general'

    i18n.changeLanguage(locale)
    localStorage.setItem('lang',locale)
    localStorage.setItem('theme',getTheme)
    localStorage.setItem("isNotification", notificationsData[0].isShow ? "false": "true")
    localStorage.setItem("isSound", notificationsData[1].isShow ? "true": "false")
    localStorage.setItem('tradeName',tradeName);

    this.props.callbackSetting([getLang,getTheme,tradeName]);
    this.props.cbCloseSetting(false);

    if(isSwitchAccount){
      this.updateMainPage();
    }else{
      this.chgNavIndexfun();
    }
  }
  chgNavIndexfun(){
    let navIdAPP=sessionStorage.getItem('navIdAPP')
    this.props.callbackChgNavIndex(navIdAPP, true)
    sessionStorage.setItem('navId',navIdAPP)
  }
  //初始化数据
  onLoadDataFun(){
    let lang=localStorage.getItem('lang')
    let theme=localStorage.getItem('theme')
    let isNotification=localStorage.getItem('isNotification')
    let isSound=localStorage.getItem('isSound')
    let tradeName=localStorage.getItem('tradeName')
    this.setState({
      getLang:!lang?'zh-CN':lang,
      langIndex:lang=='zh-CN'?0:1,
      getTheme:theme=='Light'?'Light':'Dark',
      isDarkMode:theme=='Light'?false:true,
      notificationsData:[
        {
          name:'Hide Alert Notifications',
          isShow:isNotification === "true" ? false : true
        },
        {
          name:'Notifications Sound',
          isShow:isSound === "true" ? true : false
        }
      ],
      simpleTradeData:{
        isShow:tradeName=='simple'?true:false
      }
    })
  }
  // 是否签署
  onOpenClick(){
    const {riskStatus,loading} = this.state;
    if(loading) return;
    if(riskStatus == 1){
        this.setState({
        riskVisible:true
      });
    }else{
      this.setState({
        agreeNoticeVisible:true
      });
    }
  }
  // 檢查是否簽署
  riskNoticeFun(){
    fetch(common.getHttpZs+'getSignRiskNotice',{
      method:'POST',
      headers:{
        'Accept':'application/json,text/plain,*/*',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
        token:sessionStorage.getItem('token'),
        source_type:'0015',
      })
    })
    .then(res1 => res1.json())
    .then(res1 => {
      if(res1['status']==0){
        // sign_status: [0]已签署，[1]未签署，[10]签署中
        let sign_status=res1['data']['sign_status'];
        this.setState({
          riskStatus:sign_status,
        });
      } else {
        //获取失败
        message.warning({
          content: res1['message'],
        });
      }
    })
    .catch(error => {
      console.error('Error fetching risk notice:', error);
      message.error('Failed to fetch risk notice.');
    })
    .finally(() => {
      this.setState({ loading: false });
    });
  }
  // 簽署複委託風險預告書
  cbRiskDataFun(btn){
    this.setState({
      riskVisible:false
    });

    if(btn==='Y'){
      this.setState({
        onlineVisible:true
      });
    }
  }
  // 線上簽署
  cbOnlineDataFun(btn, isSwitchAccount){
    this.setState({
      onlineVisible:false,
      isSwitchAccount
    });

    if(btn==='Y'){
      this.setState({
        agreeVisible:true
      });
    }else{
      this.setState({
        riskVisible:true
      });
    }
  }
  // 是否同意簽署
  cbAgreeDataFun(btn){
    if(btn==='Y'){
      this.setState({
        agreeNoticeVisible:true,
        agreeVisible:false
      });
    }else{
      this.setState({
        onlineVisible:true,
        agreeVisible:false,
      });
    }
  }
  // 已簽署
  cbAgreeNoticeDataFun(sign){
    this.setState({
      agreeNoticeVisible:false,
    });

    if(sign === 'open'){
      this.setState({
        riskVisible:true
      });
    }
  }
  // 切换账号回到首页
  updateMainPage(){
    const {locationName}=this.props;

    const pathName='/'+locationName[1]+'/Quote';
    const navIdAPP=sessionStorage.getItem('navIdAPP');
    const target=sessionStorage.getItem('target');
    
    sessionStorage.setItem('isSwitchFirstShow','N');

    // 关闭trade页面
    if(navIdAPP=='quote'){
      this.props.cbCloseRightPageFun();
    }else{
      this.props.callbackPathnameApp(pathName);// 获取路由跳转--app.js
    }
    // 切换账号更新list列表数据---navIdAPP=='quote'
    if(navIdAPP=='quote'){
      this.props.cbSwitchFun()
      if(target=='trade'){
        this.props.chgAccountFun()
      }
    }
    this.updateData();
  };
  // 更改数据
  updateData(){
    const target=sessionStorage.getItem('target');
    const chgNavId=target=='trade'?'trade':'quote';

    sessionStorage.setItem('navIdAPP','quote');
    sessionStorage.setItem('navId',chgNavId);

    this.props.callbackChgNavIndex(chgNavId);
  }
  //初始化
  componentDidMount(){
    this.onLoadDataFun()
    this.riskNoticeFun()
  }
  render() {
    const {t,bodyW,bodyH,mobilebodyW,ChgThemeData,isMobile} = this.props;
    const {langData,langIndex,isDarkMode,notificationsData,minH550,chgCloseImg,simpleTradeData,riskVisible,agreeVisible,agreeNoticeVisible,onlineVisible,loading}=this.state;
    return (
      <div className={styles.setting_fixed}>
        <div 
          className={[
            APPstyles.flex_column,
            styles.setting_con,
            ChgThemeData=='Light'?APPstyles.bg_light:APPstyles.bg_content_dark
          ].join(' ')}
          style={{
            height:bodyW>mobilebodyW?bodyH>minH550?'auto':'80%':'100%',
            minHeight:bodyW>mobilebodyW?bodyH>minH550?492:'80%':'100%',
            width:bodyW>mobilebodyW?522:'100%'
          }}
        >
          <div 
            className={[
              styles.header,
              styles.min48_con,
              bodyW>mobilebodyW?APPstyles.flex_between:APPstyles.flex_row,
              ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark
            ].join(' ')}
            style={{
              padding:bodyW>mobilebodyW?'0 16px':'0 8px'
            }}
          >
            <img 
              src={ChgThemeData=='Light'?leftLightImg:leftImg}  
              className={APPstyles.img24} 
              style={{
                display:bodyW>mobilebodyW?'none':'',
                marginRight:4
              }}
              alt='back' 
              onClick={()=>{
                this.chgNavIndexfun()
                this.props.cbCloseSetting(false)
              }} 
            />
            <span className={ChgThemeData=='Light'?APPstyles.color_theme_black:APPstyles.color_white}>{t('Settings')}</span>
            <img 
              src={chgCloseImg} 
              className={APPstyles.img24} 
              style={{
                display:bodyW>mobilebodyW?'':'none'
              }}
              alt='close' 
              onClick={()=>{
                this.chgNavIndexfun()
                this.props.cbCloseSetting(false)
              }}   
              onMouseOver={()=>{
                let imgurl=ChgThemeData=='Light'?closeOnLightImg:closeOnImg
                this.setState({
                  chgCloseImg:imgurl
                })
              }} 
              onMouseOut={()=>{
                this.setState({
                  chgCloseImg:closeImg
                })
              }}  
            />
          </div>
          <div className={[styles.body,APPstyles.flex1_auto].join(' ')}>
            <span
              className={[
                styles.title,
                ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark,
                ChgThemeData=='Light'?APPstyles.color_grey:APPstyles.color_grey1,
                isMobile?ChgThemeData=='Dark'?APPstyles.fontSize13_colorWhite:APPstyles.fontSize13_colorDark:''
              ].join(' ')}
            >
              {t('Language')}
            </span>
            {
              langData.map((item,index) => {
              return  <div 
                        className={[
                          styles.min48_con,
                          styles.msg,
                          APPstyles.flex_between,
                          ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark,
                          isMobile?ChgThemeData=='Dark'?APPstyles.fontSize16_colorWhite:APPstyles.fontSize16_colorDark:''
                        ].join(' ')}
                        key={index}
                      >
                        <span>{t(item['name'])}</span>
                        <img
                          className={APPstyles.img24} 
                          src={langIndex==index?settingOnImg:checkOffImg} 
                          alt='radio' 
                          onClick={()=>{
                            //选择语言
                            this.setState({
                              langIndex:index,
                              getLang:index==0?'zh-CN':'en-US'
                            })
                          }}
                        />
                      </div>
              })
            }
            <div className={[styles.line,ChgThemeData=='Light'?APPstyles.bg_list_light:APPstyles.line_dark].join(' ')}></div>
            <span
              className={[
                styles.title,
                ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark,
                ChgThemeData=='Light'?APPstyles.color_grey:APPstyles.color_grey1,
                isMobile?ChgThemeData=='Dark'?APPstyles.fontSize13_colorWhite:APPstyles.fontSize13_colorDark:''
              ].join(' ')}
            >
              {t('Appearance')}
            </span>
            <div 
              className={[
                styles.min48_con,
                styles.msg,
                APPstyles.flex_between,
                ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark,
                isMobile?ChgThemeData=='Dark'?APPstyles.fontSize16_colorWhite:APPstyles.fontSize16_colorDark:''
              ].join(' ')}
            >
              <span>{t('Dark Mode')}</span>
              <Switch 
                checked={isDarkMode} 
                onChange={(disabled )=>{
                  this.setState({
                    isDarkMode:disabled,
                    getTheme:disabled?'Dark':'Light'
                  })
                }} 
              />
            </div>
            <div className={[styles.line,ChgThemeData=='Light'?APPstyles.bg_list_light:APPstyles.line_dark].join(' ')}></div>
            <span
              className={[
                styles.title,
                ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark,
                ChgThemeData=='Light'?APPstyles.color_grey:APPstyles.color_grey1,
                isMobile?ChgThemeData=='Dark'?APPstyles.fontSize13_colorWhite:APPstyles.fontSize13_colorDark:''
              ].join(' ')}
            >
              {t('Notifications')}
            </span>
            {notificationsData.map((item,index) => {
              return  <div 
                        className={[
                          styles.min48_con,
                          styles.msg,
                          APPstyles.flex_between,
                          ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark,
                          isMobile?ChgThemeData=='Dark'?APPstyles.fontSize16_colorWhite:APPstyles.fontSize16_colorDark:''
                        ].join(' ')}
                        key={index}
                      >
                        <span>{t(item['name'])}</span>
                        <Switch 
                          checked={item['isShow']} 
                          onChange={(disabled )=>{
                            notificationsData[index]['isShow']=disabled
                            this.setState({
                              notificationsData:notificationsData
                            })
                          }} 
                        />
                      </div>
              })
            }
            <div className={[styles.line,ChgThemeData=='Light'?APPstyles.bg_list_light:APPstyles.line_dark].join(' ')}></div>
            <span
              className={[
                styles.title,
                ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark,
                ChgThemeData=='Light'?APPstyles.color_grey:APPstyles.color_grey1,
                isMobile?ChgThemeData=='Dark'?APPstyles.fontSize13_colorWhite:APPstyles.fontSize13_colorDark:''
              ].join(' ')}
            >
              {t('Trade')}
            </span>
            <div 
              className={[
                styles.min48_con,
                styles.msg,
                APPstyles.flex_between,
                ChgThemeData=='Light'?APPstyles.borderBottom_light:APPstyles.borderBottom_dark,
                isMobile?ChgThemeData=='Dark'?APPstyles.fontSize16_colorWhite:APPstyles.fontSize16_colorDark:''
              ].join(' ')}
            >
              <span>{t('Simple Page')}</span>
              <Switch 
                checked={simpleTradeData['isShow']} 
                onChange={(disabled )=>{
                  simpleTradeData['isShow']=disabled
                  this.setState({
                    simpleTradeData:simpleTradeData
                  })
                }} 
              />
            </div>
            <div className={[styles.line,ChgThemeData=='Light'?APPstyles.bg_list_light:APPstyles.line_dark].join(' ')}></div>
            <div 
              className={[
                styles.min48_con,
                styles.onLineCon,
                APPstyles.flex_between,
                ChgThemeData=='Light'?APPstyles.color_grey:APPstyles.color_grey1,
              ].join(' ')}
            >
              <span>{t('線上簽署')}</span>
              <span className={[loading?APPstyles.bg_grey:APPstyles.bg_blue,loading?'':APPstyles.btn_blue].join(' ')} style={{cursor: 'pointer'}} onClick={this.onOpenClick.bind(this)}>{t('開啟')}</span>
            </div>
            <div className={[styles.line,ChgThemeData=='Light'?APPstyles.bg_list_light:APPstyles.line_dark].join(' ')}></div>
          </div>
          <div
            className={[
              styles.footer,
              ChgThemeData=='Light'?APPstyles.borderTop_light:APPstyles.borderTop_dark
            ].join(' ')}
          >
            <Button 
              type='default' 
              className={[APPstyles.bg_grey,APPstyles.btn_gray].join(' ')} 
              onClick={this.cancelClick.bind(this)} 
            >
              {t('Cancel')}
            </Button>
            <Button 
              type='default' 
              className={[APPstyles.bg_blue,APPstyles.btn_blue].join(' ')}
              onClick={this.saveClick.bind(this)} 
            >
              {t('Save')}
            </Button>
          </div>
        </div>
        {riskVisible &&
          <RiskComponents 
            {...this.props} 
            visible={riskVisible}
            cbBtnDataFun={(sign)=>this.cbRiskDataFun(sign)}
          />
        }
        {onlineVisible &&
          <OnlineComponents 
            {...this.props} 
            visible={onlineVisible}
            cbBtnDataFun={(sign, isSwitchAccount)=>this.cbOnlineDataFun(sign, isSwitchAccount)}
            cbUpageAid={(value)=>{}}
          />
        }
        {agreeVisible &&
          <AgreeComponents 
            {...this.props}
            visible={agreeVisible}
            cbBtnDataFun={(sign)=>this.cbAgreeDataFun(sign)}
          />
        }
        {agreeNoticeVisible &&
          <AgreeNoticeComponents 
            {...this.props} 
            visible={agreeNoticeVisible}
            actions='setting'
            cbBtnDataFun={(sign)=>this.cbAgreeNoticeDataFun(sign)}
          />
        }
      </div>
    )
  }
}
export default withTranslation()(settingIndex);